<div class="page-body">
  @if (showBackButton) {
    <div class="inner-navigation">
      <div class="back" (click)="navigateBack()">
        <p class="text-button-small">{{ 'edit-insurance-info.back-button-text' | translate }}</p>
      </div>
    </div>
  }
  <div class="page-title">
    <div class="title">
      <p>{{ 'edit-insurance-info.page-title' | translate: { petName: petData.pet_name } }}</p>
    </div>
  </div>
  <div class="table-container">
    <div class="table-header">
      <div class="header-cell" [class.selected]="showPackage=='A'" (click)="setShowPackage('A')">
        <p class="body-14">{{ 'edit-insurance-info.accident' | translate }}</p>
      </div>
      <div class="header-cell" [class.selected]="showPackage=='S'" (click)="setShowPackage('S')">
        <p class="body-14">{{ 'edit-insurance-info.basic' | translate }}</p>
      </div>
      <div class="header-cell" [class.selected]="showPackage=='M'" (click)="setShowPackage('M')">
        <p class="body-14">{{ 'edit-insurance-info.regular' | translate }}</p>
      </div>
      <div class="header-cell" [class.selected]="showPackage=='L'" (click)="setShowPackage('L')">
        <p class="body-14">{{ 'edit-insurance-info.complete' | translate }}</p>
      </div>
    </div>
    <div class="table-cost">
      <div class="price-container">
        <div class="price-per-month"><p class="subtitle-14">CHF {{ baseCostPerSelectedSubscriptionInterval() | number:'1.2-2' }}
        / {{ getSubscriptionInterval() }}</p></div>
        <div class="price-overall">
          <span class="body-14">{{ 'edit-insurance-info.covering-vet-bills' | translate }}</span>
          <span class="body-14">
            @switch (showPackage) {
              @case ('A') {
                CHF 6’000
              }
              @case ('S') {
                CHF 3’000
              }
              @case ('M') {
                CHF 6’000
              }
              @case ('L') {
                {{ 'edit-insurance-info.unlimited' | translate }}
              }
            }
          </span>
        </div>
      </div>
      <div class="actions">
        <button class="button"
          [ngClass]="{'primary-light': showPackage !== selectedPackage, 'primary': showPackage === selectedPackage}"
          (click)="selectPackage(showPackage)">
          {{ (showPackage === selectedPackage ? 'edit-insurance-info.selected' : 'edit-insurance-info.select') | translate }}
        </button>
      </div>
    </div>
    <div class="table-rows">
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.annual-vet-fee-limit' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.AnnualVetFee)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @switch (showPackage) {
            @case ('A') {
              <p class="body-12">CHF 6’000</p>
            }
            @case ('S') {
              <p class="body-12">CHF 3’000</p>
            }
            @case ('M') {
              <p class="body-12">CHF 6’000</p>
            }
            @case ('L') {
              <p class="body-12">{{ 'edit-insurance-info.unlimited' | translate }}</p>
            }
          }
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.treatment-costs' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.TreatmentAccidentsAndIllness)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @if (isAccidentPackage()) {
            <p class="body-12">{{ 'edit-insurance-info.accident' | translate }}</p>
          } @else {
            <div class="circle primary">
              <mat-icon svgIcon="check"></mat-icon>
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.dental-treatment' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.DentalCover, true)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @switch (showPackage) {
            @case ('A') {
              <p class="body-12">{{ 'edit-insurance-info.accident' | translate }}</p>
            }
            @case ('S') {
              <p class="body-12">{{ 'edit-insurance-info.accident' | translate }}</p>
            }
            @case ('M') {
              <p class="body-12">{{ 'edit-insurance-info.accident-illness' | translate }}</p>
            }
            @case ('L') {
              <p class="body-12">{{ 'edit-insurance-info.accident-illness' | translate }}</p>
            }
          }
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.emergency-minding' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.EmergencyCare)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @switch (showPackage) {
            @case ('A') {
              <p class="body-12">CHF 1’000</p>
            }
            @case ('S') {
              <p class="body-12">CHF 1’000</p>
            }
            @case ('M') {
              <p class="body-12">CHF 1’500</p>
            }
            @case ('L') {
              <p class="body-12">CHF 2’000</p>
            }
          }
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.behavioural-treatment' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.BehaviouralTreatment)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @if (isAccidentPackage()) {
            <div class="circle error">
              <mat-icon svgIcon="cross"></mat-icon>
            </div>
          } @else {
            <div class="circle primary">
              <mat-icon svgIcon="check"></mat-icon>
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.complementary-treatment' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.AlternativeTreatment)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @switch (showPackage) {
            @case ('M') {
              <p class="body-12">CHF 1’500</p>
            }
            @case ('L') {
              <p class="body-12">CHF 2’500</p>
            }
            @default {
              <div class="circle error">
                <mat-icon svgIcon="cross"></mat-icon>
              </div>
            }
          }
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.worldwide-protection' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.AddtlCoverageGlobalCoverage)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          <div class="circle primary">
            <mat-icon svgIcon="check"></mat-icon>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row-name">
          <p class="subtitle-12">{{ 'edit-insurance-info.advanced-treatments' | translate }}</p>
        </div>
        <div class="row-info">
          <div class="info-icon" (click)="showInfo(InfoMessages.AdvancedTreatment)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="row-value">
          @switch (showPackage) {
            @case ('A') {
              <div class="circle error">
                <mat-icon svgIcon="cross"></mat-icon>
              </div>
            }
            @case ('S') {
              <div class="circle error">
                <mat-icon svgIcon="cross"></mat-icon>
              </div>
            }
            @case ('M') {
              <div class="circle error">
                <mat-icon svgIcon="cross"></mat-icon>
              </div>
            }
            @case ('L') {
              <div class="circle primary">
                <mat-icon svgIcon="check"></mat-icon>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
  <!-- the accident package offers no add-on coverages -->
  @if (!isAccidentPackage()) {
    <div class="title">
      <h4
      class="text-center">{{ 'edit-insurance-info.addl-insurance-title' | translate: { petName: petData.pet_name } }}</h4>
    </div>
    <div class="addl-coverages">
      <div class="block">
        <div class="top-row">
          <div class="icon">
            <!--          <mat-icon svgIcon="dna-icon"></mat-icon>-->
            <img src="/assets/preexisting-conditions-new.png" alt="">
          </div>
          <div class="text-container">
            <div class="title-container">
              <p class="subtitle-14">{{ 'edit-insurance-info.pre-existing-conditions' | translate }}</p>
              <div class="info-icon" (click)="showInfo(InfoMessages.AddtlCoveragePreexistingConditions, true)">
                <mat-icon svgIcon="i-icon"></mat-icon>
              </div>
            </div>
            <div class="text">
              <p class="body-12">{{ 'edit-insurance-info.pre-existing-conditions-text' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="bottom-row">
          <div class="cost" [class.hidden]="!calculatedPremiumResponse.preexistingConditionsPremium">
            + CHF {{ preExistingConditionsCoverageCostPerMonth() }} /mo
          </div>
          <div class="action">
            <button class="button"
              [ngClass]="{'primary-light': !preExistingConditionsCoverage, 'primary':preExistingConditionsCoverage}"
              (click)="toggleAdditionalCoverage()">
              {{ (preExistingConditionsCoverage ? 'edit-insurance-info.added' : 'edit-insurance-info.add') | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="top-row">
          <div class="icon">
            <img src="/assets/medical-food-new.svg" alt="">
          </div>
          <div class="text-container">
            <div class="title-container">
              <p class="subtitle-14">{{ 'edit-insurance-info.food' | translate }}</p>
              <div class="info-icon" (click)="showInfo(InfoMessages.MedicinalFood)">
                <mat-icon svgIcon="i-icon"></mat-icon>
              </div>
            </div>
            <div class="text">
              <p class="body-12">{{ 'edit-insurance-info.food-text' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="bottom-row">
          <div class="cost" [class.hidden]="!calculatedPremiumResponse.medicalFoodCoveragePremium">
            + CHF {{ medicalFoodCostPerMonth() }} /mo
          </div>
          <div class="action">
            <button class="button"
              [ngClass]="{'primary-light': !medicalFoodCoverage, 'primary': medicalFoodCoverage}"
              (click)="toggleMedicalFoodCoverage()">
              {{ (medicalFoodCoverage ? 'edit-insurance-info.added' : 'edit-insurance-info.add') | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="top-row">
          <div class="icon">
            <img src="/assets/preventive-treatment-new.svg" alt="">
          </div>
          <div class="text-container">
            <div class="title-container">
              <p class="subtitle-14">{{ 'edit-insurance-info.preventive-treatment' | translate }}</p>
              <div class="info-icon" (click)="showInfo(InfoMessages.PreventiveTreatment, true)">
                <mat-icon svgIcon="i-icon"></mat-icon>
              </div>
            </div>
            <div class="text">
              <p class="body-12">{{ 'edit-insurance-info.preventive-treatment-text' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="bottom-row">
          <div class="cost" [class.hidden]="!calculatedPremiumResponse.preventionCoveragePremium">
            + CHF {{ preventiveCostPerMonth() }} /mo
          </div>
          <div class="action">
            <button class="button"
              [ngClass]="{'primary-light': !preventiveCoverage, 'primary': preventiveCoverage}"
              (click)="togglePreventiveCoverage()">
              {{ (preventiveCoverage ? 'edit-insurance-info.added' : 'edit-insurance-info.add') | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="excess-container">
    <div class="block">
      <div class="row">
        <div class="title">
          <p class="subtitle-14">{{ 'edit-insurance-info.franchise' | translate }}</p>
          <div class="info-icon" (click)="showInfo(InfoMessages.Excess)">
            <mat-icon svgIcon="i-icon"></mat-icon>
          </div>
        </div>
        <div class="inline-select">
          @for (option of getFranchiseOptions(); track option; let i = $index) {
            <label [for]="'selectedFoption'+i" [class.selected]="option === selectedFranchise"
              >
              <input [id]="'selectedFoption'+i" type="radio" [value]="option" [(ngModel)]="selectedFranchise"
                (change)="calculatePremium()">
                <span>{{ option.label }}</span>
              </label>
            }
          </div>
        </div>
      </div>
      <div class="block">
        <div class="row">
          <div class="title">
            <p class="subtitle-14">{{ 'edit-insurance-info.cost-coverage' | translate }}</p>
            <div class="info-icon" (click)="showInfo(InfoMessages.Copayment, true)">
              <mat-icon svgIcon="i-icon"></mat-icon>
            </div>
          </div>
          <div class="inline-select">
            @for (option of getCostOptions(); track option; let i = $index) {
              <label [for]="'selectedCostOption'+i" [class.selected]="option === selectedCost"
                >
                <input [id]="'selectedCostOption'+i" type="radio" [value]="option" [(ngModel)]="selectedCost"
                  (change)="calculatePremium()">
                  <span>{{ option.label }}</span>
                </label>
              }
            </div>
          </div>
        </div>

        <div class="block">
          <div class="row">
            <div class="title">
              <p class="subtitle-14">{{ 'edit-insurance-info.payment-interval' | translate }}</p>
              <div class="info-icon" (click)="showInfo(InfoMessages.PaymentInterval, true)">
                <mat-icon svgIcon="i-icon"></mat-icon>
              </div>
            </div>
            <div class="inline-select">
              <div class="label-with-hint">
                <label for="selectedPaymentInterval1"
                  [class.selected]="selectedPaymentInterval === PaymentFrequency.MONTHLY">
                  <input id="selectedPaymentInterval1" type="radio" [value]="PaymentFrequency.MONTHLY"
                    [(ngModel)]="selectedPaymentInterval" (change)="onPaymentIntervalChange()">
                    <span>{{ 'edit-insurance-info.payment-intervals.monthly' | translate }}</span>
                  </label>
                </div>
                <div class="label-with-hint">
                  <label for="selectedPaymentInterval2"
                    [class.selected]="selectedPaymentInterval === PaymentFrequency.QUARTERLY">
                    <input id="selectedPaymentInterval2" type="radio" [value]="PaymentFrequency.QUARTERLY"
                      [(ngModel)]="selectedPaymentInterval" (change)="onPaymentIntervalChange()">
                      <span>{{ 'edit-insurance-info.payment-intervals.quarterly' | translate }}</span>
                    </label>
                    <p class="hint body-14 primary">{{ 'edit-insurance-info.frequency-discount.quarterly-discount' | translate}}</p>
                  </div>
                  <div class="label-with-hint">
                    <label for="selectedPaymentInterval3"
                      [class.selected]="selectedPaymentInterval === PaymentFrequency.BIYEARLY">
                      <input id="selectedPaymentInterval3" type="radio" [value]="PaymentFrequency.BIYEARLY"
                        [(ngModel)]="selectedPaymentInterval" (change)="onPaymentIntervalChange()">
                        <span>{{ 'edit-insurance-info.payment-intervals.biyearly' | translate }}</span>
                      </label>
                      <p class="hint body-14 primary">{{ 'edit-insurance-info.frequency-discount.biyearly-discount' | translate}}</p>
                    </div>
                    <div class="label-with-hint">
                      <label for="selectedPaymentInterval4"
                        [class.selected]="selectedPaymentInterval === PaymentFrequency.YEARLY">
                        <input id="selectedPaymentInterval4" type="radio" [value]="PaymentFrequency.YEARLY"
                          [(ngModel)]="selectedPaymentInterval" (change)="onPaymentIntervalChange()">
                          <span>{{ 'edit-insurance-info.payment-intervals.yearly' | translate }}</span>
                        </label>
                        <p class="hint body-14 primary">{{ 'edit-insurance-info.frequency-discount.yearly-discount' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer" [class.desktop]="isDesktop">
              <div class="total-price">
                <span class="subtitle-16">{{ 'edit-insurance-info.total' | translate }}</span>
                <span class="subtitle-20">CHF {{ costPerSelectedSubscriptionInterval() | number: '1.2-2' }}</span>
                <span class="subtitle-20">{{ getSubscriptionInterval() }}</span>
              </div>
              @if (savingsPerInterval() > 0) {
                <div class="savings">
                  <span class="body-14">{{ 'edit-insurance-info.you-save' | translate }}</span>
                  <span class="subtitle-16">CHF {{ savingsPerInterval() | number: '1.2-2' }}</span>
                  <span class="subtitle-16">{{ getSubscriptionInterval() }}</span>
                </div>
              }
              <div class="button-container">
                <button class="button white" [disabled]="!isEditInsuranceFieldsChanged()" (click)="saveChanges()">
                  {{ 'edit-insurance-info.save-changes' | translate }}
                </button>
              </div>
            </div>
